import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import LegalLayout from "@/components/LegalLayout";

export default function MentionsLegales() {
  return (
    <Layout>
      <LegalLayout title="Mentions légales" testId="legal-notice-page">
        <h2>Éditeur du site</h2>
        <p>
          Le site Doudou Alert est édité par une <strong>personne physique</strong> exerçant en nom propre.
        </p>
        <ul>
          <li><strong>Éditrice :</strong> Carole Georgeon</li>
          <li><strong>Adresse de contact :</strong> à fournir prochainement (domiciliation en cours)</li>
          <li><strong>Email :</strong> contact@doudou-alert.fr</li>
          <li><strong>Statut :</strong> Particulier (un statut sera enregistré si des services payants sont proposés ultérieurement)</li>
          <li><strong>Directrice de la publication :</strong> Carole Georgeon</li>
        </ul>
        <p className="text-sm text-stone-500">
          <em>
            Conformément à l'article 6 de la loi n° 2004-575 du 21 juin 2004 (LCEN), les éditeurs non-professionnels
            peuvent conserver leurs coordonnées privées en les communiquant uniquement à l'hébergeur. Une adresse de
            domiciliation professionnelle sera publiée dès la création formelle de la structure éditrice.
          </em>
        </p>

        <h2>Hébergement</h2>
        <p>
          Le site est hébergé sur les infrastructures de <strong>Emergent / Kubernetes</strong> (cluster cloud sécurisé)
          avec base de données MongoDB Atlas (région UE).
        </p>

        <h2>Responsable du traitement des données</h2>
        <p>
          L'éditeur ci-dessus est responsable du traitement des données à caractère personnel au sens du RGPD.
          Aucun DPO (délégué à la protection des données) n'est désigné, le traitement étant à l'échelle d'une
          activité individuelle. Pour toute question, contactez <strong>contact@doudou-alert.fr</strong>.
        </p>

        <h2>Propriété intellectuelle</h2>
        <p>
          L'ensemble des éléments composant le site — code source, design, charte graphique, logo,
          dénomination « Doudou Alert », textes éditoriaux — est la <strong>propriété exclusive de l'éditeur</strong>,
          protégé par le Code de la propriété intellectuelle (articles L111-1 et suivants).
        </p>
        <p>
          Les <strong>photos et descriptions publiées par les utilisateurs</strong> restent la propriété de leurs
          auteurs. En les publiant sur Doudou Alert, l'utilisateur concède une licence non exclusive, gratuite et
          mondiale d'affichage à Doudou Alert pour les seuls besoins du service.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication ou exploitation, totale ou partielle, des
          éléments de Doudou Alert est interdite sans autorisation écrite préalable.
        </p>

        <h2>Crédits techniques</h2>
        <ul>
          <li>Cartes : <a href="https://www.openstreetmap.org" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors</li>
          <li>Icônes : <a href="https://phosphoricons.com" target="_blank" rel="noopener noreferrer">Phosphor Icons</a> (licence MIT)</li>
          <li>Polices : Nunito et Inter via Google Fonts</li>
          <li>Composants UI : Shadcn UI (licence MIT), Tailwind CSS</li>
          <li>Paiements : <a href="https://stripe.com" target="_blank" rel="noopener noreferrer">Stripe</a></li>
        </ul>

        <h2>Signaler un contenu</h2>
        <p>
          Conformément à la LCEN, tout contenu manifestement illicite peut être signalé à
          <strong> contact@doudou-alert.fr</strong>. Nous nous engageons à examiner toute notification sous 72 heures
          et à retirer promptement tout contenu illicite.
        </p>

        <h2>Médiation de la consommation</h2>
        <p>
          Conformément à l'article L612-1 du Code de la consommation, en cas de litige non résolu entre un
          consommateur et l'éditeur, le consommateur peut recourir gratuitement à un médiateur de la consommation.
          Plateforme européenne de règlement en ligne :
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer"> ec.europa.eu/consumers/odr</a>.
        </p>

        <h2>Droit applicable</h2>
        <p>
          Les présentes mentions légales sont soumises au droit français. En cas de litige et à défaut de résolution
          amiable, les tribunaux français seront seuls compétents.
        </p>

        <p className="text-sm text-stone-500 mt-8">
          Voir aussi : <Link to="/cgu">CGU</Link> · <Link to="/confidentialite">Politique de confidentialité</Link>
        </p>
      </LegalLayout>
    </Layout>
  );
}
